import { AttendancePage } from "@/pages/AttendancePage";

/**
 * The attendance view of a registrar course record
 * (`/admin/courses/{courseId}?view=attendance`; a `&session=` link opens the same register).
 *
 * The registrar's register is oversight: the matrix, never the roll. A class's
 * destination is edited on the class portal. The course is the address, so there
 * is no section picker; a closed term stays readable and takes no new classes.
 */
export function RegistrarCourseAttendance({ courseId }: { courseId: string }) {
  return <AttendancePage key={courseId} workspace="registrar" courseId={courseId} embedded />;
}
